import styled, { keyframes } from "styled-components";
export const shimmer = keyframes`
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
`;
